export var Type;
(function (Type) {
    Type["AREA"] = "AREA";
    Type["ROW"] = "ROW";
    Type["MULTI_ROW"] = "MULTI_ROW";
    Type["TABLE"] = "TABLE";
    Type["ROUND_TABLE"] = "ROUND_TABLE";
    Type["SHAPE"] = "SHAPE";
})(Type || (Type = {}));
export var PlaceTypeEnumType;
(function (PlaceTypeEnumType) {
    PlaceTypeEnumType["UNKNOWN_PROPERTY"] = "UNKNOWN_PROPERTY";
    PlaceTypeEnumType["STANDARD"] = "STANDARD";
    PlaceTypeEnumType["WHEELCHAIR"] = "WHEELCHAIR";
    PlaceTypeEnumType["ACCESSIBLE"] = "ACCESSIBLE";
    PlaceTypeEnumType["COMPANION"] = "COMPANION";
    PlaceTypeEnumType["OBSTRUCTED"] = "OBSTRUCTED";
    PlaceTypeEnumType["DISCOUNT"] = "DISCOUNT";
})(PlaceTypeEnumType || (PlaceTypeEnumType = {}));
export var ShapeTypeEnumType;
(function (ShapeTypeEnumType) {
    ShapeTypeEnumType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    ShapeTypeEnumType["TEXT"] = "TEXT";
    ShapeTypeEnumType["RECTANGLE"] = "RECTANGLE";
    ShapeTypeEnumType["ELLIPSE"] = "ELLIPSE";
    ShapeTypeEnumType["LINE"] = "LINE";
    ShapeTypeEnumType["ICON"] = "ICON";
    ShapeTypeEnumType["IMAGE"] = "IMAGE";
})(ShapeTypeEnumType || (ShapeTypeEnumType = {}));
export var Position;
(function (Position) {
    Position["UNKNOWN_POSITION"] = "UNKNOWN_POSITION";
    Position["LEFT"] = "LEFT";
    Position["RIGHT"] = "RIGHT";
    Position["BOTH"] = "BOTH";
    Position["NONE"] = "NONE";
})(Position || (Position = {}));
export var Icon;
(function (Icon) {
    Icon["UNKNOWN_ICON"] = "UNKNOWN_ICON";
    Icon["ENTER"] = "ENTER";
    Icon["EXIT"] = "EXIT";
    Icon["DRINKS"] = "DRINKS";
    Icon["WC"] = "WC";
    Icon["WC_MEN"] = "WC_MEN";
    Icon["WC_WOMEN"] = "WC_WOMEN";
    Icon["FOOD"] = "FOOD";
    Icon["STAIRS"] = "STAIRS";
    Icon["ELEVATOR"] = "ELEVATOR";
    Icon["SMOKING"] = "SMOKING";
    Icon["CHECKROOM"] = "CHECKROOM";
    Icon["STAGE"] = "STAGE";
})(Icon || (Icon = {}));
export var Numbering;
(function (Numbering) {
    Numbering["UNKNOWN_NUMBERING"] = "UNKNOWN_NUMBERING";
    Numbering["NUMERIC"] = "NUMERIC";
    Numbering["ODD_EVEN"] = "ODD_EVEN";
    Numbering["ALPHABETICAL"] = "ALPHABETICAL";
})(Numbering || (Numbering = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Fieldset;
(function (Fieldset) {
    Fieldset["ELEMENTS"] = "ELEMENTS";
    Fieldset["CATEGORIES"] = "CATEGORIES";
    Fieldset["PLACES"] = "PLACES";
    Fieldset["CONFIG"] = "CONFIG";
    Fieldset["ELEMENT_GROUPS"] = "ELEMENT_GROUPS";
})(Fieldset || (Fieldset = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map